import React from 'react';
import { Grid2, TextField } from '@mui/material';

function TikTokForm({ values, setFieldValue }) {
    return (
        <>
            <Grid2 size={{ xs: 12 }}>
                <TextField
                    fullWidth
                    label="TikTok Pixel ID"
                    value={values.settings?.trackingId || ''}
                    onChange={(ev) =>
                        setFieldValue('settings', {
                            ...values.settings,
                            trackingId: ev.target.value,
                        })
                    }
                    placeholder="XXXXXXXXXXXX"
                    helperText="Enter your TikTok Pixel ID"
                />
            </Grid2>
        </>
    );
}

export default TikTokForm;
